import React from 'react';
import PageTitle from '../PageTitle';
import { doRequest } from '../../helper';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
export default class MaiBhiChowkidarModeration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            response: null,
            postCount: 0,
            status: 'Active',

        }
        this.update = this.update.bind(this);
        this.getPosts = this.getPosts.bind(this);
        this.batchUpdate = this.batchUpdate.bind(this);
        this.selectToggle = this.selectToggle.bind(this);

    }
    componentDidMount() {
        var status = this.props.match.params.status;
        if (!status) {
            status = "enabled";
        }

        this.getPosts(status);

    }
    componentWillReceiveProps(nextProps) {
        var status = nextProps.match.params.status;
        if (!status) {
            status = "enabled";
        }
        this.getPosts(status);
    }
    getPosts(status) {

        $("#loader").css({ 'display': 'block' });
        var ref = this;
        ref.setState({ "items": [] });
        var request = doRequest('cms-operations', {
            'action': 'list-posts',
            'module': 'maiBhiChowkidar',
            'model': 'post',
            'data': {
                'direction': 'desc',
                'status': status,
                'limit': ref.state.limit
            }  
        }, true) 
        request.addEventListener("load", function () {
            var response = this.responseText;
            console.log(response);
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    console.log(response.Count);
                    ref.setState({ "response": response, "items": response.items, "lastIndex": response.lastEvaluatedKey, "postCount": response.countdata.Count, "status": status }, () => {
                        $("#loader").css({ 'display': 'none' });
                    });
                }
            } catch (ex) {

            }

        });
    }
    batchUpdate(status) {
        var ids = [];
        var createds = [];
        $(".multi_select:checked").each(function () {
            ids.push($(this).attr('data-id'));
            createds.push($(this).attr('data-created'));
        })
        var id = ids.join(',');
        var created = createds.join(',');

        if (id == "") {
            alert("No post selected");
        } else {
            this.update(id, created, status);
        }

    }
    update(id, created, status) {
        id = "" + id;
        var request = doRequest('cms-operations', {
            'action': 'update-post',
            'module': 'maiBhiChowkidar',
            'model': 'post',
            'data': {
                'id': id,
                'status': status,
                'created': created
            }
        }, true);

        request.addEventListener("load", function () {
            var response = this.responseText;
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    var ids = id.split(",");
                    ids.map(function (id_value) {
                        $("#post_" + id_value).hide();
                    })

                }
            } catch (ex) {

            }

        });
    }
    selectToggle() {
        if ($(".allChecked").length > 0) {

            $(".multi_select").prop("checked", false);
            $(".multi_select").removeClass("allChecked");

        } else {


            $(".multi_select").prop("checked", true);
            $(".multi_select").addClass("allChecked");
        }

    }
    render() {

        var bread = "MaiBhiChowkidar / Moderation (Active Posts)";
        var pagelink = "/maiBhiChowkidar/moderation";
        if (this.props.match.params.status == "disabled") {
            bread = "MaiBhiChowkidar/ Moderation (Disabled Posts)";
            pagelink += "/disabled";
        } else {
            pagelink += "/enabled";
        }
        var items = this.state.items;
        var links = [{
            'link': '/maiBhiChowkidar/moderation/disabled',
            'name': 'View Disabled Posts'
        }, {
            'link': '/maiBhiChowkidar/moderation/enabled',
            'name': 'View Active Posts'
        }]
        var pagination = [];
        if (this.state.response && countdata) {
            var countdata = this.state.response.countdata;
            var pages = Math.ceil(countdata.Count / this.state.limit);

            for (var i = 1; i <= pages; i++) {
                pagination.push(<span key={i}><NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">{i}</NavLink>&nbsp;</span>);
            }
        }
        return (

            <div>
                <PageTitle title="#MaiBhiChowkidar" bread={bread} links={links} Count={this.state.postCount} counttype={this.state.status == "enabled" ? "Active " : this.state.status == "disabled" ? "Inactive " : ""} />
                <div className="wrapper wrapper-content">
                    {this.props.match.params.status != "disabled" ?
                        <a className="btn btn-warning btn-xs" onClick={() => { this.batchUpdate('disable') }} type="button"><i className="fa fa-times"></i>&nbsp;Disable All Checked</a>
                        :
                        <a className="btn btn-primary btn-xs" onClick={() => { this.batchUpdate('enable') }} type="button"><i className="fa fa-check"></i>&nbsp;Enable All Checked</a>}
                    &nbsp;&nbsp;<a href="javascript:void(0);" onClick={this.selectToggle}><i className="fa fa-check"></i>&nbsp;Select All Toggle</a>
                    &nbsp; Page : {pagination}
                    <br /><br />
                    <div className="row">
                        <div className="col-lg-12">
                            {Array.isArray(items) && items.map((value, index) => {
                                return (<div class="file-box" key={index} id={"post_" + value.id}>
                                    <div class="file">
                                        <a href="javascript:void(0);">
                                            <span class="corner"></span>

                                            <div class="image" style={{ "height": "auto" }}>
                                                {!value.social_post_type ? <img alt="image" class="img-responsive" src={value.canvasImage} /> : <div style={{ "height": "100px" }}>{value.social_post_link}</div>}
                                                <div className="image_caption">
                                                    {value.disabled == 0 ? <a href="javascript:void(0);" className="btn btn-warning btn-circle" onClick={() => { this.update(value.id, value.created, 'disable') }} type="button"><i className="fa fa-times"></i>
                                                    </a> : <a href="javascript:void(0);" className="btn btn-info btn-circle " onClick={() => { this.update(value.id, value.created, 'enable') }} type="button"><i className="fa fa-check"></i>
                                                        </a>}


                                                </div>
                                                <a href="javascript:void(0);" style={{ "position": "absolute", "top": "10px", "left": "10px" }} className="btn btn-info btn-circle " type="button">
                                                    <input data-created={value.created} data-id={value.id} type="checkbox" className="multi_select" style={{ "margin": "2px" }} />
                                                </a>
                                            </div>
                                            <div class="file-name">
                                                {value.user_name_display ? value.user_name_display : ""}
                                                <br />
                                                <small>{value.user_email ? value.user_email : ""}</small>
                                                <br />
                                                <small>Added: {value.created ? value.created : ""}</small>
                                                <br />
                                                <b style={{ "wordWrap": "break-word" }}>{value.social_post_link}</b>


                                            </div>
                                        </a>

                                    </div>
                                </div>)

                            })}

                        </div>
                    </div>

                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/Components/MaiBhiChowkidar/Moderation.jsx